var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-multiselect',{attrs:{"options":_vm.options,"track-by":_vm.trackBy,"label":_vm.label,"searchable":false,"allowEmpty":true,"multiple":_vm.multiple,"value":_vm.selected},on:{"input":_vm.handleInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }